import CardHeader from '@/components/Includes/CardHeader/CardHeader.vue';
import IProfile from '@/interfaces/IProfile';
import IUsersGroup from '@/interfaces/IUsersGroup';
import IMultiSelectItem from '@/interfaces/selects/IMultiSelectItem';
import IUserForm from '@/interfaces/users/IUserForm';
import IUserFormProps from '@/interfaces/users/IUserFormProps';
import Multiselect from 'vue-multiselect';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { ROLES } from "@/constants";
import { Action, Getter } from 'vuex-class';
import cloneObject from '@/libs/cloneObject';


@Component({
    name: 'UserForm',
    components: {
        Multiselect,
        CardHeader
    }
})
export default class UserForm extends Vue {
    @Prop(Object) private formData!: IUserFormProps;

    @Action private usersGroupsList!: () => Promise<void>;
    @Getter private getUsersGroups!: () => IUsersGroup[];

    @Action private createUser!:(form:IUserForm) => Promise<void>;

    @Action private updateUser!:(form:IUserForm) => Promise<void>;

    @Getter private profile!: IProfile;

    private form: IUserForm | null = null

    private groups:IUsersGroup[] = [];
    private selectedGroups: IMultiSelectItem[] = [];

    private isEdit: boolean = false;
    private loading: boolean = true;

    private selectedRoles: IMultiSelectItem[] = []

    private get roles() {
        return ROLES;
    }

    private get rootRole() {
        const roles = this.profile.roles;
        
        if(roles) {
            return  !!roles.find((role:string) => role === 'ROLE_USER')
        }
    }

    private get isAdmin() {
        const roles = this.profile.roles;

        if (roles) {
            return roles.includes('ROLE_ADMIN');
        }
    }

    private get headerTitle() {
        return this.$route.name === 'profile' ? 'Profile' : 'User';
    }

    private get btnIcon() {
        return !this.isEdit ? 'icon-pencil' : 'icon-lock';
    }

    private get editBtnText() {
        return !this.isEdit ? 'Edit' : 'Lock';
    }

    private get isCreateForm() {
        const expression = this.$route.name === 'user_create';
        this.isEdit = expression;
        return expression;
    }

    private get btnText() {
        return this.isCreateForm ? 'Create' : 'Update';
    }

    private transformMultySelects(base:any){
        return base.map(({id, name}:any) => ({
            value: id,
            label: name
        }));
    }

    private transformRolesMultiselect(base:any){
        return base.map((role:any) => ({
            value: role,
            label: role,
            $isDisabled: role === 'ROLE_USER'
        }));
    }

    private groupInStock(){
        const groups = this.formData.groups;

        if(groups){
            if(this.notEmpty(groups)){
                this.selectedGroups = this.transformMultySelects(groups);
            }
        }
    }

    private rolesInStock(){
        const roles = this.formData.roles;

        if(roles){
            if(this.notEmpty(roles)) {
                this.selectedRoles = this.transformRolesMultiselect(roles);
            }
        }
    }

    private editForm() {
        return (this.isEdit = !this.isEdit);
    }

    private validPassword() {
        if (!this.form) {
            return
        }

        if(this.form.plainPassword){
            if(this.form.plainPassword.length > 0) {
                const expression = this.form.plainPassword === this.form.confirmPassword;
                
                if(!expression) {
                    this.$notify({
                        group: 'notice',
                        title: 'Rejected Passwords',
                        text: 'Passwords do not match',
                        type: 'error'
                    });
                }
                
                return expression;
            } else {
                return !this.form.plainPassword;
            }
        } else {
            return true;
        }
    }

    private sendForm() {
        if (!this.form) {
            return
        }

        if(this.validPassword()) {
            const prefix: string = '/api/main';
            
            const transformSelectedGroups = this.selectedGroups.map(group => {
                return `${prefix}/groups/${group.value}`;
            });

            const transformSelectedRoles = this.selectedRoles.map(role => String(role.value));

            if (!transformSelectedRoles.includes('ROLE_USER')) {
                transformSelectedRoles.push('ROLE_USER');
            }

            let form: IUserForm = {
                id: this.form.id,
                username: this.form.username,
                email: this.form.email,
                groups: transformSelectedGroups,
                roles: transformSelectedRoles
            };

            if(this.form.plainPassword){
                if(this.form.plainPassword.length > 0) {
                    form = {
                        ...form,
                        plainPassword: this.form.plainPassword
                    }
                }
            }
                
            if(this.isCreateForm) {
                this.createUser(form)
            } else {
                this.updateUser(form)
            }
        }
    }

    private cancelForm() {
        this.$router.go(-1);
    }

    private notEmpty(data:any) {
        return data.length !== 0;
    }

    private created() {
        this.form = cloneObject({
            ...this.formData,
            plainPassword: '',
            confirmPassword: ''
        })
    }

    private async mounted() {
        if(this.formData){
            this.groupInStock();
            this.rolesInStock();
        }
        try {
            this.groups = this.transformMultySelects(this.getUsersGroups());
            
            if (!this.notEmpty(this.getUsersGroups())) {
                await this.usersGroupsList();
                this.groups = this.transformMultySelects(this.getUsersGroups());
            }
            this.loading = false;
        } catch (error) {
            console.error(error);
        }
    }
}
